module.exports = __webpack_public_path__ + "static/media/rapidNaming-intro1.8ee014fe.mp3";